import React from 'react';
import PropTypes from 'prop-types';

import { ValidationStatusModal } from '../UIComponents';
import Footnote from '../Footnote';

import { DENTAL } from '../../assets/Domains';

import './index.scss';

const currencyMap = {
  USD: '$',
};

export default class Plans extends React.Component {
  constructor() {
    super();

    this.state = {
      isChangePlanStatusVisible: false,
    };

    this.onPlanChangeStatusClose = this.onPlanChangeStatusClose.bind(this);
    this.onCurrentPlanSet = this.onCurrentPlanSet.bind(this);
  }

  componentDidMount() {
    // Fetch available plans
    this.props.getAvailablePlans();

    // Fetch client
    this.props.getClient();
  }

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.billing &&
      typeof nextProps.billing.planUpdateStatus === 'boolean' &&
      this.props.billing.planUpdateStatus !== nextProps.billing.planUpdateStatus
    ) {
      this.setState({
        isChangePlanStatusVisible: true,
      });

      setTimeout(this.onPlanChangeStatusClose, 5000);
    }
  }

  onPlanChangeStatusClose() {
    this.setState({
      isChangePlanStatusVisible: false,
    });
  }

  onCurrentPlanSet(event) {
    event.preventDefault();

    const { billing, updateActivePlan } = this.props;
    const { info } = billing;
    const activePlan = info.plan || {};

    updateActivePlan({ planId: activePlan.id });
  }

  render() {
    const { billing, updateActivePlan, currentDomain } = this.props;

    const { client, plans, info } = billing;
    const activePlan = info.plan || {};

    const isActivePlanDeprecated = !!client.switch_plan_alert;

    return (
      <div className="plans">
        <div className="plans__header">
          <h3>Get Started</h3>
          <p className="plans__header__lead">
            Simple, transparent pricing. Always know what you’ll pay.
          </p>
        </div>

        {isActivePlanDeprecated ? (
          <div className="plans__warning">
            <div className="plans__warning__icon">
              <i className="material-icons plans__warning__icon--error" aria-hidden="true">error</i>
            </div>
            <div className="plans__warning__text">
              {client.switch_plan_alert ||
                'Your plan will change to Gold effective December 1st 2018'}
            </div>
            <div className="plans__warning__action">
              <a href="" onClick={this.onCurrentPlanSet}>
                Stay on current plan
              </a>
            </div>
          </div>
        ) : (
          undefined
        )}

        <div className="plans__list">
          {plans.map((plan) => {
            const features = plan.value.description.split('\n').map((item) => {
              return item.trim();
            });

            const onSwitchPlan = (event) => {
              event.preventDefault();

              updateActivePlan({ planId: plan.id });
            };

            return (
              <div className="plan" key={plan.id}>
                <div className="plan__name">{plan.value.name}</div>
                <div className="plan__price">
                  <sup>{currencyMap[plan.value.currency_code]}</sup>
                  {plan.value.fixed_slab.unit_cost}
                  <sub>/mo</sub>
                </div>
                {currentDomain !== DENTAL ? (
                  <div className="plan__benefits">
                    {plan.value.fixed_slab.quantity} Appointments
                  </div>
                ) : null}
                <div className="plan__actions">
                  {activePlan.id === plan.id ? (
                    <button type="button" className="btn btn--primary">
                      Current Plan
                    </button>
                  ) : (
                    <button
                      type="button"
                      className="btn btn--primary inverted"
                      onClick={onSwitchPlan}
                    >
                      Switch Plan
                    </button>
                  )}
                </div>
                <div className="plan__features">
                  <ul>
                    {/* eslint react/no-array-index-key: "off" */
                    features.map((feature, index) => {
                      return <li key={index}>{feature}</li>;
                    })}
                  </ul>
                </div>
              </div>
            );
          })}
        </div>

        <ValidationStatusModal
          visibility={this.state.isChangePlanStatusVisible}
          status={this.props.billing.planUpdateStatus}
          onClose={this.onPlanChangeStatusClose}
          successMessage={this.props.billing.planUpdateMessage}
          errorMessage={this.props.billing.planUpdateMessage}
        />

        <Footnote />
      </div>
    );
  }
}

Plans.defaultProps = {
  getAvailablePlans: () => {},
  getClient: () => {},
  updateActivePlan: () => {},
  currentDomain: '',
  billing: {
    client: {},
    plans: [],
    planUpdateStatus: null,
    planUpdateMessage: '',
  },
};

Plans.propTypes = {
  getAvailablePlans: PropTypes.func,
  getClient: PropTypes.func,
  updateActivePlan: PropTypes.func,
  currentDomain: PropTypes.string,
  billing: PropTypes.shape({
    client: PropTypes.object,
    plans: PropTypes.array,
    planUpdateStatus: PropTypes.bool,
    planUpdateMessage: PropTypes.string,
  }),
};
